// Generated file : do not modify
import PlageCreneau from '@/extend/classes/PlageCreneau';
import { GraphAnswer } from '@/extend/classes/GraphData';
import { GraphMinimum } from '@/extend/classes/GraphData';
import Owner from '@/extend/classes/Owner';
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Lieux
export default class Lieu  {
  // Identifiant unique
  public id: number;
  // Libellé
  public label: string;
  // Adresse
  public adresseId: number;
  // Client
  public clientId: number;
  // PlageCreneau
  public parentObj: PlageCreneau;
  // Graph answers
  public graphAnswers: GraphAnswer[];
  // Graph minimum
  public graphMinimum: GraphMinimum;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;
  // Objet à l'origine de la requête
  public owner: Owner;

  constructor() {
    this.id = 0;
    this.label = '';
    this.adresseId = 0;
    this.clientId = 0;
    this.parentObj = new PlageCreneau();
    this.graphAnswers = [];
    this.graphMinimum = new GraphMinimum();
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
    this.owner = new Owner();
  }

  public static fromJson (obj: Lieu): Lieu {
    const newLieu: Lieu = new Lieu();
    newLieu.id = obj.id;
    newLieu.label = obj.label;
    newLieu.adresseId = obj.adresseId;
    newLieu.clientId = obj.clientId;
    newLieu.parentObj = JSON.parse(JSON.stringify(obj.parentObj));
    newLieu.graphAnswers = JSON.parse(JSON.stringify(obj.graphAnswers));
    newLieu.graphMinimum = JSON.parse(JSON.stringify(obj.graphMinimum));
    newLieu.createId = obj.createId;
    newLieu.failed = obj.failed;
    newLieu.canUpdate = obj.canUpdate;
    newLieu.canDelete = obj.canDelete;
    newLieu.display = obj.display;
    newLieu.notifDefType = obj.notifDefType;
    newLieu.owner = JSON.parse(JSON.stringify(obj.owner));
    return newLieu;
  }

  public toJsonLieu (): string {
    const json = {
      label: this.label,
      adresseId: this.adresseId,
      clientId: this.clientId,
      parentObj: this.parentObj,
      graphAnswers: this.graphAnswers,
      graphMinimum: this.graphMinimum,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromLieu (obj: Lieu): void {
    this.id = obj.id;
    this.label = obj.label;
    this.adresseId = obj.adresseId;
    this.clientId = obj.clientId;
    this.parentObj = obj.parentObj;
    this.graphAnswers = obj.graphAnswers;
    this.graphMinimum = obj.graphMinimum;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
    this.owner = obj.owner;
  }

  public compareLieu (value: Lieu): boolean {
    return (this.toJsonLieu() == value.toJsonLieu());
  }

  public cloneLieu (): Lieu {
    return Lieu.fromJson(this);
  }

  public createForStoreLieu (): Promise<Lieu> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/lieux/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromLieu(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreLieu (): Promise<Lieu> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/lieux/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromLieu(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStoreLieu (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/lieux/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/lieux/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Lieux/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = Lieu.fromJson(listData.reccords[0] as Lieu);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Lieu> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Lieux/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Lieu.fromJson(listData.reccords[0] as Lieu);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(lieus: Lieu[]) {
  }
}
